import React from 'react'
import MaterialSymbol from '../material-symbol'

const LocalOffer = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="local_offer" {...props} />
))

LocalOffer.displayName = 'LocalOffer'

export default LocalOffer
